import * as React from 'react';
const SvgUnified = (props) => (
  <svg viewBox="0 0 114 114" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#unified_svg__a)"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="M57 57H41.054a3.334 3.334 0 0 0-3.309 3.74l.849 6.944c.145 1.216.118 2.454-.209 3.636-1.112 4.038-4.803 7-9.19 7a9.527 9.527 0 0 1-9.189-7c-.327-1.182-.355-2.42-.209-3.636l.848-6.944A3.334 3.334 0 0 0 17.337 57H1.39v45.371c0 5.651 4.58 10.239 10.239 10.239h39.81M57 57v15.946a3.334 3.334 0 0 0 3.74 3.309l6.972-.855c1.216-.146 2.454-.118 3.635.208 4.04 1.113 7 4.804 7 9.19 0 4.824-3.587 8.814-8.244 9.447-.723.097-1.46.07-2.19-.021-1.508-.188-4.65-.57-7.18-.876a3.334 3.334 0 0 0-3.74 3.309v15.946h45.371c5.651 0 10.239-4.581 10.239-10.239v-39.9M1.39 51.439v-39.81C1.39 5.98 5.972 1.39 11.63 1.39H57v16.294c0 2.002-1.751 3.559-3.74 3.309-2.425-.292-5.428-.66-7.013-.855-1.21-.146-2.447-.119-3.629.208-4.031 1.105-7 4.803-7 9.19 0 4.386 2.969 8.084 7 9.196 1.182.32 2.42.348 3.636.202l7.007-.855A3.334 3.334 0 0 1 57 41.388V57h15.938c2.051 0 3.525-1.668 3.275-3.698l-.807-6.61c-.146-1.217-.118-2.454.209-3.636 1.105-4.032 4.803-7 9.19-7 4.386 0 8.084 2.968 9.189 7 .326 1.182.354 2.419.208 3.635l-.806 6.611C93.147 55.332 94.62 57 96.671 57h15.939V11.63c0-5.652-4.581-10.24-10.239-10.24H62.388" />
    </g>
    <defs>
      <clipPath id="unified_svg__a">
        <path fill="#fff" d="M0 0h114v114H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgUnified;
